var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"item-center"},[_c('v-col',{staticClass:"item-center",attrs:{"cols":"12"}},[_c('v-sheet',{staticClass:"item-center",attrs:{"rounded":"","elevation":"2","width":"50%"}},[_c('h5',{staticClass:"ma-0 t-black"},[_vm._v(_vm._s(_vm.$t(_vm.msg)))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }